module.exports = __webpack_public_path__ + "public/images/partners/sup-3.da3dd021204bc16699c574dfd6582dd0.png";